import { FC, useMemo }     from 'react';
import Style               from './DatePicker.style';
import dayjs               from 'dayjs';
import { DatePickerProps } from 'antd';

type TProps = {
  value?: number,
  format?: string,
  showTime?: boolean,
  defaultValue?: number,
  onChange?: (value: number | null) => void,
  picker?: 'date' | 'month' | 'year',
}

export const DatePicker: FC<TProps> = ({ value, format = 'DD.MM.YYYY', defaultValue, onChange, ...props }) => {

  const handleOnChange: DatePickerProps['onChange'] = (value) => {
    if (onChange && typeof onChange === 'function') {
      if (!value) {
        return onChange(null);
      }
      onChange(value.unix() * 1000);
    }
  };

  const picker = useMemo(() => {
    if (props.picker) {
      return props.picker;
    }
    switch (true) {
      case format === 'YYYY':
        return 'year';
      case format === 'MM.YYYY':
        return 'month';
      case format === 'DD.MM.YYYY':
      default:
        return 'date';
    }
  }, [ props.picker, format ]);

  const val = value || defaultValue;

  return (
    <Style
      showTime={false}
      {...props}
      picker={picker}
      format={format}
      value={val ? dayjs(val) : null}
      /* @ts-ignore */
      onChange={handleOnChange}
    />
  );
};
